import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit, isEmpty, scrollToComponent } from "@ui-seeker/utils"

import { useUserApp } from "@hooks"
import { USER_ROLES, WEBBACK_V2_API } from "@constants"
import { marketAnalyzerSkuDetailsFilters } from "Pages/Pricing/MarketAnalyzer/@signals"


export default function usePriceMarketAnalyzerSkuDetails() {
    const { showToast } = useAppToast()
    const { userRole } = useUserApp()

    const isLoadingDetailsTable = useSignal(false)
    const detailsTableData = useSignal([])

    useEffect(() => {
        if (!isEmpty(marketAnalyzerSkuDetailsFilters.value)) batch(() => {
            isLoadingDetailsTable.value = true
            showToast.promise(postSubmit(`${WEBBACK_V2_API}/pricing/price-evolution/table-pricing-new`, marketAnalyzerSkuDetailsFilters.value).then(res => {
				detailsTableData.value = res
                isLoadingDetailsTable.value = false
			}).catch(() => {
				isLoadingDetailsTable.value = false
				showToast.error()
			}).finally(() => scrollToComponent('sku-details-table')))
        })
        else {
            detailsTableData.value = []
        }

    }, [JSON.stringify(marketAnalyzerSkuDetailsFilters.value)])

    const handleCloseDetailsSkuTable = () => {
        detailsTableData.value = []
        marketAnalyzerSkuDetailsFilters.value = {}
    }

    return {
        skuName: marketAnalyzerSkuDetailsFilters.value.skuName,
        country: marketAnalyzerSkuDetailsFilters.value.country?.length ? marketAnalyzerSkuDetailsFilters.value.country[0] : null,
        isLoadingDetailsTable: isLoadingDetailsTable.value,
        detailsTableData: detailsTableData.value,
        isStandardUser: userRole === USER_ROLES.STANDARD,
        handleCloseDetailsSkuTable: handleCloseDetailsSkuTable
    }
}